<template>
  <el-row>
    <!--    -=-=-=-={{$userProfile}}-->
    <!--    <el-card >-->


    <!--      <el-button-->
    <!--          type="warning"-->
    <!--          :disabled="!vehicleData || !vehicleData.id"-->
    <!--          circle-->
    <!--          @click.stop="initialView()"-->
    <!--          class="pull-right" >-->
    <!--        <i class="material-icons" >refresh</i >-->
    <!--      </el-button >-->
    <!--      <span-->
    <!--          v-if="vehicleData && vehicleData.id"-->
    <!--          style="font-size: 18px; font-weight: bolder"-->
    <!--          :class="{-->
    <!--          deleted: vehicleData.archived == 1,-->
    <!--          archived: vehicleData.archived == 2,-->
    <!--        }" >-->
    <!--        <small >Vehicle:</small >-->
    <!--        {{ vehicleData.name ? vehicleData.name : "" }}-->
    <!--      </span >-->
    <!--      <span-->
    <!--          v-else-->
    <!--          style="font-size: 18px; font-weight: bolder" >All Vehicles</span >-->
    <!--      &lt;!&ndash;      <el-button&ndash;&gt;-->
    <!--      &lt;!&ndash;          label="all"&ndash;&gt;-->
    <!--      &lt;!&ndash;          key="all"&ndash;&gt;-->
    <!--      &lt;!&ndash;          @click="transactions_status=['all']" >All&ndash;&gt;-->
    <!--      &lt;!&ndash;      </el-button >&ndash;&gt;-->

    <!--    </el-card >-->

    <el-tabs
        type="border-card" v-model="activeName">
      <el-tab-pane name="tasks">
          <span slot="label">
                 <el-button
                     v-if="vehicleData&&vehicleData.id"
                     type="warning"
                     @click='routeGo({
          name: "manageVehicle",
          params: { vehicleid: "all" },
        });'>
              ALL
            </el-button>
            <i class="material-icons">schedule</i> Tasks/Notes </span>
        <div>
          <div>
            <el-checkbox-group
                class="pull-right"
                @change="workingView = 'translist'"
                v-model="transactions_status"
                size="medium">

              <el-checkbox-button
                  label="high-priority"
                  key="high-priority">Highpriority Tasks
              </el-checkbox-button>
              <el-checkbox-button
                  label="expired"
                  key="expired">Expired
              </el-checkbox-button>
              <el-checkbox-button
                  label="pending"
                  key="Pending">Pending
              </el-checkbox-button>
              <el-checkbox-button
                  label="done"
                  key="Done">Done
              </el-checkbox-button>
              <el-checkbox-button
                  label="notes"
                  key="Notes">Notes
              </el-checkbox-button>
            </el-checkbox-group>

            <sf-button
                v-if="vehicleData&&vehicleData.id"
                type="success"
                @click="loadTask()">
              <i class="material-icons">add_circle_outline</i> <i class="material-icons">insert_invitation</i>
            </sf-button>
          </div>
          <s-table
              :key="clock"
              height-wish="-40"
              ref="vehiclesList"
              :rowClassFactory="taskStyller"
              :colDefinitions="colTasksDefinitions"
              modx-processor="fueldrafts/getlist"
              :r-query="qTasks"
              xdata-loaded="switchTabs"
              @cell-clicked="loadTask"></s-table>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="vehicleData" name="form">
        <span slot="label">
      Details    <i class="material-icons">airport_shuttle</i> {{ vehicleData.name ? vehicleData.name : "" }}
        </span>

        <s-form style="padding: 10px" class="vehicle-form">
          <s-form-actions
              slot="actions"
              v-if="vehicleData">

            <sf-button
                :type="vehicleData.archived !==1 ?'danger':'default'"
                confirm="Are you sure??? Maybe just archive it for the moment"

                @click="vehicleData.archived==1?vehicleData.archived=0:vehicleData.archived=1;updateVehicle(true)">
              <i class="material-icons">delete_forever</i>
            </sf-button>
            <sf-button
                :type="vehicleData.archived !==2 ?'warning':'default'"
                confirm="Are you sure? "

                @click="vehicleData.archived==2?vehicleData.archived=0:vehicleData.archived=2;updateVehicle(true)">
              <i class="material-icons">store</i>
            </sf-button>

            <sf-button
                type="primary"
                @click="updateVehicle()">
              <i class="material-icons">done</i>
            </sf-button>


          </s-form-actions>

          <el-row>
            <el-col
                :sm="12"
                :lg="8">
              <div>Veh. Number</div>
              <el-input
                  placeholder="Veh. Number"
                  v-model="vehicleData.name"></el-input>
            </el-col>
            <el-col
                :sm="12"
                :lg="8">
              <div>External Supplier</div>
              <s-remote-select

                  v-model="vehicleData.sapplierId"
                  class-model="sappliers"

                  query-prop="search"
                  label-prop="sappliername"
                  placeholder="Supplier"></s-remote-select>

            </el-col>
            <el-col
                :sm="12"
                :lg="8">
              <div>Veh. Driver</div>

              <s-remote-select
                  style="width:100%"
                  v-model="vehicleData.drivers"
                  class-model="contacts"
                  :extraQueryParams="{type:'driver'}"
                  :multiple="true"
                  query-prop="search"
                  label-prop="name"
                  placeholder="Drivers"></s-remote-select>
              <!--                <el-select-->
              <!--                  v-model="vehicleData.drivers"-->
              <!--                  multiple-->
              <!--                  placeholder="Drivers"-->
              <!--                  fit-width-->
              <!--                  clearable-->
              <!--                  filterable-->
              <!--                >-->
              <!--                  <el-option-->
              <!--                    v-for="item in contactList"-->
              <!--                    :key="item.id"-->
              <!--                    :label="item.name"-->
              <!--                    :value="item.id"-->
              <!--                  ></el-option>-->
              <!--                </el-select>-->
            </el-col>
            <el-col
                :sm="6"
                :lg="4">
              <div>Veh. Capacity</div>
              <el-input
                  placeholder="Veh. Capacity"
                  v-model="vehicleData.capacity"></el-input>
            </el-col>
            <el-col
                :sm="6"
                :lg="4">
              <div>{{ $t('Doors') }}</div>
              <el-input
                  :placeholder="$t('doors')"
                  v-model="vehicleData.doors"></el-input>
            </el-col>
            <el-col
                :sm="6"
                :lg="4">
              <div>Veh. Type</div>
              <s-select
                  options-repo="vehicleTypes"
                  v-model="vehicleData.type"
                  label-prop="type"
                  value-prop="type"
                  :allow-create="true"
              ></s-select>
            </el-col>
            <el-col
                :sm="6"
                :lg="4">
              <div>{{ $t('Group') }}</div>
              <s-select
                  options-repo="vehicleGroups"
                  v-model="vehicleData.vgroup"
                  label-prop="vgroup"
                  value-prop="vgroup"
                  :allow-create="true"
              ></s-select>

            </el-col>
            <el-col
                :sm="12"
                :lg="8">
              <div>Veh. IMEI</div>
              <el-input
                  placeholder="Veh. IMEI"
                  v-model="vehicleData.sn"></el-input>
            </el-col>
            <el-col
                :sm="12"
                :lg="6">
              <div>Brand</div>
              <s-select
                  autocompleteModel="Assets"
                  v-model="vehicleData.brand"
                  label-prop="brand"
                  value-prop="brand"
                  :allow-create="true"/>
              <!--              <el-input-->
              <!--                  placeholder="Brand"-->
              <!--                  v-model="vehicleData.brand"></el-input>-->
            </el-col>
            <el-col
                :sm="12"
                :lg="6">
              <div>Model</div>
              <el-input
                  placeholder="Model"
                  v-model="vehicleData.model"></el-input>
            </el-col>
            <el-col
                :sm="6"
                :lg="4">
              <div>{{ $t('power') }}</div>
              <el-input
                  placeholder="..."
                  v-model="vehicleData.power"></el-input>
            </el-col>
            <el-col
                :sm="12"
                :lg="8">
              <div>Phone Number</div>
              <el-input
                  placeholder="phone"
                  v-model="vehicleData.connectedPhone"></el-input>
            </el-col>
            <el-col
                :sm="12"
                :lg="4">
              <div>{{ $t('Color') }}</div>
              <!--              <el-input-->
              <!--                  placeholder="..."-->
              <!--                  v-model="vehicleData.color"></el-input>-->
              <s-select
                  autocompleteModel="Assets"
                  v-model="vehicleData.color"
                  label-prop="color"
                  value-prop="color"
                  :allow-create="true"
              ></s-select>
            </el-col>
            <el-col
                :sm="12"
                :lg="4">

              <div>{{ $t('Open Top') }}</div>

              <el-checkbox

                  v-model="vehicleData.openTop" :true-label="1" :false-label="0"></el-checkbox>
            </el-col>
            <el-col
                :sm="6"
                :lg="4">
              <div>{{ $t('Fuel') }}</div>
              <s-select
                  autocompleteModel="Assets"
                  v-model="vehicleData.fuelType"
                  label-prop="fuelType"
                  value-prop="fuelType"
                  :allow-create="true"
              ></s-select>

            </el-col>
            <el-col
                :sm="24"
                :lg="12">
              <div>{{ $t('specs') }}</div>
              <el-input
                  style="width:100%"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  type="textarea"
                  autosize
                  placeholder="..."
                  v-model="vehicleData.specs"></el-input>
            </el-col>
          </el-row>


          <el-card>
            <div slot="header">
              <h4 style="margin: 0px">LICENSE DETAILS</h4>
            </div>
            <el-row>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>Owner Details</div>
                <el-input
                    placeholder="Owner Details"
                    v-model="vehicleData.ownerDetails"></el-input>
              </el-col>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>Date Issued</div>
                <el-date-picker
                    type="date"
                    placeholder="Date Issued"
                    value-format="timestamp"
                    format="dd/MM/yyyy"
                    v-model="vehicleData.dateIssuedJS"
                    style="width: 100%"></el-date-picker>
              </el-col>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>First Licence Date</div>
                <el-date-picker
                    type="date"
                    placeholder="First Licence Date"
                    value-format="timestamp"
                    format="dd/MM/yyyy"
                    v-model="vehicleData.aLisenseDateJS"
                    style="width: 100%"></el-date-picker>
              </el-col>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>Gr Licence Date</div>
                <el-date-picker
                    type="date"
                    placeholder="Gr License Date"
                    value-format="timestamp"
                    format="dd/MM/yyyy"
                    v-model="vehicleData.grLisenseDateJS"
                    style="width: 100%"></el-date-picker>
              </el-col>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>Date Expires</div>
                <el-date-picker
                    type="date"
                    placeholder="Date Expires"
                    value-format="timestamp"
                    format="dd/MM/yyyy"
                    v-model="vehicleData.dateExpiresJS"
                    style="width: 100%"></el-date-picker>
              </el-col>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>Frame Num</div>
                <el-input
                    placeholder="Frame Num"
                    v-model="vehicleData.frameNum"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>{{ $t('Licence Num') }}</div>
                <el-input
                    :placeholder="$t('Licence Num')"
                    v-model="vehicleData.vLisenseNum"></el-input>
              </el-col>
              <el-col
                  :sm="12"
                  :lg="8">
                <div>{{ $t('externalOwner') }}</div>
                <el-checkbox

                    v-model="vehicleData.externalOwner" :true-label="1" :false-label="0"></el-checkbox>
              </el-col>
            </el-row>
          </el-card>

        </s-form>
      </el-tab-pane>
      <el-tab-pane v-if="vehicleData&&$route.params.vehicleid != 'all'" name="run">
        <span slot="label">
      {{ $t('Run') }}
        </span>
        <vehicle-fuels v-if="activeName=='run'" :display-vehicle-run="true"
                       :specific-asset-id="$route.params.vehicleid"></vehicle-fuels>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
        :visible.sync="taskDialog"
        :modal-append-to-body="false"
        :width="isWindowSize('sm')?'95%':'70%'">

      <VehicleTaskForm
          v-if="taskDialog"
          :vehicle="vehicleData"
          @done="++clock;taskDialog=false"
          :task-id="selectedTask"></VehicleTaskForm>

    </el-dialog>

  </el-row>
</template>

<script>
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import SRemoteSelect from "../../Form/SRemoteSelect.vue";
import VehicleFuels from "./VehicleFuels.vue";

export default {
  components: {VehicleFuels, SRemoteSelect},
  mixins: [commons],
  async mounted() {
    let vm = this;
    this.contactList = await api.fetchList("contacts");
    if (this.$route.params.vehicleid == 'all') {
      this.vehicleData = null
    } else if (this.$route.params.vehicleid == 'new') {
      this.vehicleData = {}
    } else {
      this.vehicleData = await api.fetchObject("assets", {
        id: this.$route.params.vehicleid,
      });
    }
    // await this.loadBooking();
    // this.formDada.tourCoId = this.userRelCoId
    //   ? this.userRelCoId
    //   : this.formDada.tourCoId;
    this.loading = false;
  },

  data() {
    return {
      clock: 0,
      activeName: 'form',
      taskDialog: false,
      // scheduleTripRequest: { with: "TripService" },
      vehicleData: null,
      selectedTask: null,
      loading: true,
      transactions_status: ["high-priority",
        "pending",
        "expired",
        "notes"],
      contactList: null,
      pocessing: false,
      selectedTrans: null,
      sappliers: [],
      repeaterDialog: false,
      selectedFlightId: null,
      arvFlightDate: null,
      depFlightDate: null,
    };
  },

  methods: {
    // switchTabs(ev) {
    //   if (ev?.results.length)
    //     this.activeName = 'tasks'
    //   else this.activeName = 'form'
    //   _log_('switchTabs', ev)
    //   //$event?.length?activeName='tasks':'form'
    // },
    taskStyller(row) {

      if (row.row.alerttime && !row.row.exectime) {
        if (row.row.alerttime < this.unxnow()) return 'danger'
      }
    },
    loadTask(task) {

      this.selectedTask = task ? task.row.id : 'new'
      this.taskDialog = true
    },
    createDraftDublicate() {
      var cloneTrans = _.clone(this.selected_trans),
          newtime = 0;
      cloneTrans.id = null;

      cloneTrans.exectime = null;
      cloneTrans.exectimeJS = null;
      if (this.repeatOnDate) cloneTrans.alerttimeJS = this.repeatOnDate;
      else {
        const epochTime = new Date(
            cloneTrans.exectimeJS ? cloneTrans.exectimeJS : cloneTrans.alerttimeJS
        );
        if (this.every)
          if (this.everyStep == "month")
            epochTime.setMonth(epochTime.getMonth() + this.every);
          else epochTime.setMonth(epochTime.getMonth() + this.every * 12);
        cloneTrans.alerttimeJS = epochTime.getTime();
      }
      if (!this.selected_trans.exectimeJS)
        this.$confirm(
            "You are about to create a new task without have finished this one. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
        )
            .then(() => {
              this.pipeActions(
                  ["=>fueldrafts/update>=selected_trans",
                    "->addNewDraft"],
                  cloneTrans
              );
            });
      else {
        this.pipeActions(
            ["=>fueldrafts/update>=selected_trans",
              "->addNewDraft"],
            cloneTrans
        );
      }
    },
    initialView() {
      // vehicleData={};selected_trans={};transactionsQ.assetId=null;transactionsQ.start=0;transList=[];pipeActionsLazy(
      //                   true,
      //                   "transListLoader",
      //                   null,
      //                   transactionsQ
      //               );workingView="translist"
    },
    async updateVehicle(emitRefresh) {
      this.vehicleData = await api.updateProcessor(
          "assets/update",
          this.vehicleData
      );
      if (emitRefresh) this.$emit('delete', this.vehicleData)
      else this.$emit('update', this.vehicleData)
      // pipeActions(['=>assets/update'],vehicleData);transDialogOn = true
    },
    parkVehicle() {
      // vehicleData.archived=(vehicleData.archived==2)?0:2;pipeActions(['->confirmAction','=>assets/update' ],vehicleData);vehicleData={};transactionsQ.assetId=null;transactionsQ.start=0;transList=[];pipeActionsLazy(
      //                                           true,
      //                                           'transListLoader',
      //                                           null,
      //                                           transactionsQ
      //                                       ); workingView='translist'
    },
    deleteVehicle() {
      //vehicleData.archived=(vehicleData.archived==1)?0:1;pipeActions(['->confirmAction','=>assets/update' ],vehicleData);vehicleData={};transactionsQ.assetId=null;transactionsQ.start=0;transList=[];pipeActionsLazy(
      //     true,
      //     'transListLoader',
      //     null,
      //     transactionsQ
      // ); workingView='translist'
    },
    addNewTrans() {
      //pipeActions(['=>fueldrafts/update>=selected_trans','->addNewDraft'],{assetId:vehicleData.id});workingView='transdraft';
    },
    addNewVehicle() {
      //pipeActions(['=>assets/update>=vehicleData','->addNewAsset']);workingView='asset';
    },
  },

  watch: {
    "formDada.tickePriceAdult": {
      async handler(price, oldPrice) {
        // if (
        //   !price &&
        //   !oldPrice &&
        //   this.ScheduleTrip &&
        //   this.ScheduleTrip.TripService
        // ) {
        //   // this.$set(this.formDada,'tickePriceAdult',this.ScheduleTrip.TripService.price1)
        //   this.formDada.tickePriceAdult = this.ScheduleTrip.TripService.price1;
        //   _log_(
        //     "set b oo ",
        //     this.formDada,
        //     this.formDada.tickePriceAdult
        //   );
        // }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.vehicleid": {
      async handler(vehicleid, oldvvehicleid) {
        if (vehicleid == oldvvehicleid) return
        if (vehicleid == 'all') {
          this.vehicleData = null
          this.activeName = 'tasks'
        } else if (vehicleid == 'new') {
          this.vehicleData = {}
        } else {
          this.vehicleData = await api.fetchObject("assets", {
            id: vehicleid,
          });
        }
        // this.vehicleData = await api.fetchObject("assets", {
        //   id: vehicleid,
        // });
      },
      immediate: true,
    },
  },
  computed: {
    colTasksDefinitions() {
      const vm = this
      let o = [
        // {prop: "vehicle", width: "", label: "Vehicle"},

        {
          prop: "type",

          label: "Type",
        },

        {
          prop: "alerttime",

          label: "When",
          formatter: vm.dateFromUnxTime
        },
        {prop: "title", label: "What"}
      ];
      if (this.transactions_status && this.transactions_status.includes('done'))
        o.push({prop: "exectime", width: "", formatter: vm.dateFromUnxTime, label: "Done"})
      if (this.$route.params.vehicleid == 'all')
        o.push({prop: "vehicle", width: "", label: "Vehicle"})
      return o;
    },
    qTasks() {
      return {
        assetId: this.$route.params.vehicleid != 'all' ? this.$route.params.vehicleid : null,
        status: this.transactions_status
      }
    }
  },
};
</script>

<style>
.vehicle-form .el-col {
  padding: 4px;
}
</style>
